import styled, { css } from 'styled-components'

import { Text } from '@sketch/components'

import {
  CARD_RADIUS,
  CARD_SHADOW,
  DASHED_SEPARATOR,
  TILE_MEDIA_SIZE,
} from './constants'

/**
 * Two-tile preview card shared by the downloadable-asset and add-share-member
 * previews: a centred row of tiles split by a dashed `Separator`.
 */
export const Card = styled.section(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 48px;
    width: 100%;
    padding: 40px 24px;
    border-radius: ${CARD_RADIUS};
    background: ${theme.colors.background.secondary.A};

    box-shadow: ${CARD_SHADOW};
  `
)

export const TileWrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex: 1;
`

export const Tile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  min-width: 0;
  text-align: center;
`

export const Separator = styled.div`
  border-left: 1px dashed ${DASHED_SEPARATOR};
`

export const Thumbnail = styled.div(
  ({ theme }) => css`
    width: ${TILE_MEDIA_SIZE};
    height: ${TILE_MEDIA_SIZE};
    border-radius: 12px;
    margin-bottom: 8px;
    background: ${theme.colors.foreground.secondary.A};
  `
)

export const TileTitle = styled(Text).attrs({
  textStyle: 'prominent.secondary.D',
})`
  margin: 0;
  max-width: 160px;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`

export const TileMeta = styled(Text).attrs({
  textStyle: 'prominent.secondary.D',
})`
  margin: 0;
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`
